import { ANSWERS } from 'common/domain/constants';

class SickLeaveQuestionController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_CONFIRMATION_PART'
      }, {
        literal: 'VACATIONS_ABSENCES.SICK_LEAVE_QUESTION.BUTTON_SICK_LEAVE_PART'
      }
    ];
  }

  continueSickness() {
    this.choose(ANSWERS.YES);
  }

  cancelSickness() {
    this.choose(ANSWERS.NO);
  }

  choose(answer) {
    this.onSelection(this.EventEmitter({answer}));
  }
}

export default SickLeaveQuestionController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/sickLeaveQuestion/sickLeaveQuestion.controller.js